define(
({
  "load_error": "불러오기 오류",
  "description": "요청이 올바로 완료되지 않았습니다. 주문이 저장되었는지 확인하고 이 페이지를 새로고침하세요."
})
);
